import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxPermissionsModule } from "ngx-permissions";
import { DynamicFormModule } from "./components/dynamic-form/dynamic-form.module";
import { LoaderInterceptorService } from "./components/loader/loader-interceptor.service";
import { LoaderComponent } from "./components/loader/loader.component";
import { TextConfirmComponent } from "./components/text-confirm/text-confirm.component";
import { BlockCopyPasteCutDirective } from "./directives/block-copy-past-cut.directive";
import { NgZorroModule } from "./ngzorro.module";
import { BrDate, BrDateHM, BrDateZ } from "./pipes/br-date.pipe";
import { CPFPipe } from "./pipes/cpf.pipe";
import { RgPipe } from "./pipes/rg.pipe";
import { ArraySortPipe } from "./pipes/sort-array.pipe";
import { TelefonePipe } from "./pipes/telefone.pipe";
import { MenuCardIconComponent } from "./components/menu-card-icon/menu-card-icon.component";
import { HeaderPageComponent } from "./components/header-page/header-page.component";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { ResultadoProtocoloComponent } from "./components/resultado-protocolo/resultado-protocolo.component";
import { TitleSectionComponent } from "./components/title-section/title-section.component";
import { PaginationPipe } from "./pipes/pagination.pipe";
import { CNPJPipe } from "./pipes/cnpj.pipe";
import { TableCadastroComponent } from "./components/table-cadastro/table-cadastro.component";
import { DynamicFormComponent } from "./components/dynamic-form/components/dynamic-form/dynamic-form.component";
import { OrderByPipe } from "./pipes/order.pipe";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { UploadArquivoComponent } from "./components/upload-arquivo/upload-arquivo.component";
import { TelefoneXXPipe } from "./pipes/telefone-xx.pipe";
import { TruncateTextPipe } from "@core/pipes/truncate-text.pipe";
import { ModalErro409Component } from "./components/modal-erro-409/modal-erro-409.component";
import { EmailSearchSelectComponent } from "./components/email-search-select/email-search-select.component";
import { EmailModalComponent } from "./components/email-search-select/email-modal/email-modal.component";
import { EmailInativarModalComponent } from "./components/email-search-select/email-inativar-modal/email-inativar-modal.component";

// import { NgApexchartsModule } from "ng-apexcharts";
// import { UploadComponent } from "./components/upload/upload.component";
// import { UploadPictureWallComponent } from "./components/upload-picture-wall/upload-picture-wall.component";

@NgModule({
  declarations: [
    LoaderComponent,
    BrDate,
    BrDateHM,
    BrDateZ,
    BlockCopyPasteCutDirective,
    TextConfirmComponent,
    CPFPipe,
    RgPipe,
    TelefonePipe,
    ArraySortPipe,
    MenuCardIconComponent,
    CNPJPipe,
    HeaderPageComponent,
    PaginationComponent,
    ResultadoProtocoloComponent,
    TitleSectionComponent,
    PaginationPipe,
    TableCadastroComponent,
    DynamicFormComponent,
    OrderByPipe,
    UploadArquivoComponent,
    TelefoneXXPipe,
    TruncateTextPipe,
    ModalErro409Component,
    EmailSearchSelectComponent,
    EmailModalComponent,
    EmailInativarModalComponent
  ],
  exports: [
    NgZorroModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    DynamicFormModule,
    LoaderComponent,
    BrDate,
    CNPJPipe,
    BrDateHM,
    BrDateZ,
    BlockCopyPasteCutDirective,
    TextConfirmComponent,
    CPFPipe,
    RgPipe,
    TelefonePipe,
    ArraySortPipe,
    MenuCardIconComponent,
    HeaderPageComponent,
    PaginationComponent,
    TitleSectionComponent,
    PaginationPipe,
    DynamicFormComponent,
    OrderByPipe,
    UploadArquivoComponent,
    TelefoneXXPipe,
    TruncateTextPipe,
    EmailSearchSelectComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true,
    },
    // provideNgxMask(),
  ],
  imports: [
    CommonModule,
    NgZorroModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DynamicFormModule,
    NgxPermissionsModule.forChild(),
    NgxMaskDirective,
    NgxMaskPipe,
    AngularEditorModule
  ],
})
export class SharedModule { }
